
(function () {
    'use strict';

  /**
   * @ngdoc service
   * @name commons.service:PopupManager
   *
   * @description
   *
   */
  angular
    .module('commons')
    .service('PopupManager', PopupManager);

  function PopupManager($uibModal, $document) {
    var self = this;
    var openModals = {};

    var modalConfig = {
      ASSIGN_PARING: {
        animation: true,
        templateUrl: 'crewing_assign_pairing.tpl.html',
        controller: 'AssignPairingModalCtrl',
        controllerAs: 'assignCtrl',
        windowClass: 'add-pattern-modal-window',
        size: 'sm'
      },
      REPLACE_PARING: {
        animation: true,
        templateUrl: 'crewing_replace_pairing.tpl.html',
        controller: 'ReplacePairingModalCtrl',
        controllerAs: 'replaceCtrl',
        windowClass: 'add-pattern-modal-window',
        size: 'sm'
      },
      REGULATION_DETAILS: {
        animation: true,
        templateUrl: 'crewing_assign_pairing_regulation_details.tpl.html',
        controller: 'RegulationDetailsCtrl',
        controllerAs: 'regulationCtrl',
        windowClass: 'table-modal-window',
        size: 'sm'
      },
      ASSIGN_TRAINING: {
        animation: true,
        templateUrl: 'crewing_assign_training.tpl.html',
        controller: 'AssignTrainingCtrl',
        controllerAs: 'trainingCtrl',
        windowClass: 'add-training-modal-window',
        size: 'sm'
      },
      ASSIGN_EVENT: {
        animation: true,
        templateUrl: 'crewing_assign_event.tpl.html',
        controller: 'AssignEventCtrl',
        controllerAs: 'eventCtrl',
        windowClass: 'add-event-modal-window',
        size: 'sm'
      },
      CONFIRM_DIALOG: {
        animation: true,
        templateUrl: 'confirm_dialog.tpl.html',
        controller: 'ConfirmDialogCtrl',
        controllerAs: 'confirmCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      },
      INFO_DIALOG: {
        animation: true,
        templateUrl: 'info_dialog.tpl.html',
        controller: 'InfoDialogCtrl',
        controllerAs: 'infodialogctrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      },
      HISTORY_DETAILS: {
        animation: true,
        templateUrl: 'crewing_history.tpl.html',
        controller: 'ShowHistoryCtrl',
        controllerAs: 'historyCtrl',
        windowClass: 'history-modal-window',
        size: 'sm'
      },
      TRAINING_SYNC: {
        animation: true,
        templateUrl: 'training_sync_response.tpl.html',
        controller: 'showTrainingSyncCtrl',
        controllerAs: 'trainingSyncCtrl',
        windowClass: 'training-sync-modal-window',
        size: 'sm'
      },
      ADD_EDIT_MEMO: {
        animation: true,
        templateUrl: 'add_memo.tpl.html',
        controller: 'AddMemoCtrl',
        controllerAs: 'memo',
        windowClass: 'add-memo-modal-window',
        backdrop  : 'static',
        size: ''
      },
      SHOW_EXPIRY: {
        animation: true,
        templateUrl: 'show_expiry.tpl.html',
        controller: 'ShowExpiryInfoCtrl',
        controllerAs: 'expiry',
        windowClass: 'show-expiry-modal-window',
        size: ''
      },
      FLIGHT_UPDATE_POPUP: {
        animation: true,
        templateUrl: 'flight-watch/views/flight-watch-update-pop-up.tpl.html',
        controller: 'FlightWatchUpdateCtrl',
        controllerAs: 'FlightWatchUpdate',
        windowClass: 'flightinfo-modal-window',
        size: ''
      },
      STATION_FLIGHT_HANDLING_POPUP: {
        animation: true,
        templateUrl: 'station-flight-handling/components/station-flight-handling-pop-up-component.html',
        controller: 'StationFlightHandlingPopUpCtrl',
        controllerAs: 'StationFlightHandlingPopUp',
        windowClass: 'flightinfo-modal-window',
        size: '',
        backdrop  : 'static',
        keyboard :false
      },
      FLIGHT_SEND_NOTIFICATION: {
        animation: true,
        templateUrl: 'flight-watch-send-notification-popup.tpl.html',
        controller: 'FlightWatchSendNotificationCtrl',
        controllerAs: 'FlightWatchSendNotificationCtrl',
        windowClass: 'flight-crew-notification-modal-window',
        size: ''
      },
      ADD_CHECK_POPUP: {
        animation: true,
        templateUrl: 'flight-watch/views/flight-watch-add-check.tpl.html',
        controller: 'AddNewCheckCtrl',
        controllerAs: 'NewCheck',
        windowClass: 'addnewcheck-modal-window',
        size: ''
      },
      FLIGHT_CHECK_LOG_DETAILS: {
        animation: true,
        templateUrl: 'flight-watch/views/flight-check-log-details-popup.tpl.html',
        controller: 'FlightCheckLogDetailsCtrl',
        controllerAs: 'FlightCheckLogDetailsCtrl',
        windowClass: '',
        size: 'md'
      },
      BULK_PATTERN_UPDATE_RESPONSE_DETAILS: {
        animation: true,
        templateUrl: 'manage-pairing/views/pairing-bulk-update-response-popup.tpl.html',
        controller: 'PairingBulkUpdateResponseCtrl',
        controllerAs: 'PairingBulkUpdateResponseCtrl',
        windowClass: 'tracking-filter-popup-window',
        size: 'md',
        backdrop  : 'static',
        keyboard :false
      },
      SMS: {
        animation: true,
        templateUrl: 'sms.tpl.html',
        controller: 'SendSmsCtrl',
        controllerAs: 'sms',
        windowClass: 'sms-modal-window',
        size: 'lg'
      },
      EVALUATE_TRAININGS: {
        animation: true,
        templateUrl: 'evaluate_trainings.tpl.html',
        controller: 'EvaluateTrainingsCtrl',
        controllerAs: 'evalTrainings',
        windowClass: 'training-modal-window',
        size: 'lg'
      },
      ADD_EDIT_DISTANCE: {
        animation: true,
        templateUrl: 'add_edit_distance.tpl.html',
        controller: 'AddEditDistanceCtrl',
        controllerAs: 'distance',
        windowClass: 'distance-modal-window',
        size: 'md'
      },
      REPLY: {
        animation: true,
        templateUrl: 'reply.tpl.html',
        controller: 'ReplyCtrl',
        controllerAs: 'reply',
        windowClass: 'reply-modal-window',
        size: 'md'
      },
      MESSAGE_MANAGER: {
        animation: true,
        templateUrl: 'message-manager.tpl.html',
        controller: 'MessageManagerModalCtrl',
        controllerAs : 'messageManager',
        windowClass: 'message-manager-modal-window',
        size: 'lg'
      },
      ALERT: {
        animation: true,
        templateUrl: 'alert.tpl.html',
        controller: 'SendAlertCtrl',
        controllerAs: 'alert',
        windowClass: 'alert-modal-window',
        size: 'lg'
      },
      MISSING_ITEMS_CREATE_PAIRING: {
        animation: true,
        templateUrl: 'missing_items_popup.tpl.html',
        controller: 'MissingItemsCtrl',
        controllerAs: 'missingItems',
        windowClass: 'missing-items-popup-window',
        size: 'lg'
      },
      GENERATE_PAIRING: {
        animation: true,
        templateUrl: 'generate_pairing.tpl.html',
        controller: 'GeneratePairingCtrlCtrl',
        controllerAs : 'generatePairing',
        windowClass: 'generatepattern-modal-window',
        size: 'sm'
      },
      ILLEGAL_CREW_MAP: {
        animation: true,
        templateUrl: 'illegalCrewMap.tpl.html',
        controller: 'IllegalCrewMapCtrl',
        controllerAs : 'illegalCrewMap',
        windowClass: 'missing-items-popup-window',
        size: 'sm'
      },
      CREW_FILTER: {
        animation: true,
        templateUrl: 'crewFilter.tpl.html',
        controller: 'CrewingFilterModalCtrl',
        controllerAs : 'crewFilter',
        windowClass: 'table-modal-window',
        keyboard:false,
        size: 'sm'
      },
      CONFLICTS_TRAININGS: {
        animation: true,
        templateUrl: 'conflicts-trainings.tpl.html',
        controller: 'conflictsTrainingsCtrl',
        controllerAs : 'conflictsTrainings',
        windowClass: 'missing-items-popup-window-training',
        size: 'sm'
      },
      TRACKING_FLIGHT_FILTER : {
        templateUrl: 'tracking_flightFilter.tpl.html',
        animation: true,
        controller: 'FilghtFilterCtrl',
        controllerAs : 'flightFilter',
        windowClass: 'tracking-filter-popup-window',
        size: 'sm'
      },
      TRAINING_ASSIGN_CREW: {
        templateUrl: 'training-programs/views/training_assign_crew.tpl.html',
        animation: true,
        controller: 'TrainingAssignCrewCtrl',
        controllerAs : 'assignCrew',
        windowClass: 'table-modal-window training-multiple-crew-assign',
        size: 'sm'
      },
      CONFIRM_SHOW_IN_PORTAL : {
        templateUrl: 'confirm-show-in-portal.tpl.html',
        animation: true,
        controller: 'ShowInCrewPortalCtrl',
        controllerAs : 'showInCrewPortal',
        windowClass: 'alert-small-modal-window',
        size: 'sm'
      },
      SHOW_IN_VIOLATIONS : {
        templateUrl: 'show_violations.tpl.html',
        animation: true,
        controller: 'ShowDistWarningCtrl',
        controllerAs : 'showViolations',
        windowClass: 'table-modal-window',
        size: 'sm'
      },
      MULTIPLE_SMS_SEND_POPUP: {
        animation: true,
        templateUrl: 'message/views/view-popup-send-alert-manager.tpl.html',
        controller: 'MultipleAlertSendPopUpCtrl',
        controllerAs: 'multipleAlertSendCtrl',
        windowClass: 'table-modal-window',
        size: 'sm'
      },
      EXPIRY_TRAINING_ASSIGN_POPUP: {
        animation: true,
        templateUrl: 'renewals/views/expiry-training-assign.tpl.html',
        controller: 'AssignExpiryTrainingCtrl',
        controllerAs: 'assignExpiryAssign',
        windowClass: 'training-multiple-crew-assign',
        size: 'lg'
      },

      BIDDING_ERROR_POPUP: {
        animation: true,
        templateUrl: 'bidding/components/bidding-error-msg.tpl.html',
        controller: 'BiddingAssignCtrl',
        controllerAs: 'biddingAssign',
        windowClass: 'training-multiple-crew-assign',
        size: 'lg'},

      JOURNEY_LOG_POPUP: {
        animation: true,
        templateUrl: 'duty-sheet/views/journey-log.tpl.html',
        controller: 'JourneyLogCtrl',
        controllerAs: 'journeyLog',
        windowClass: 'table-modal-window training-multiple-crew-assign',
        size: 'sm'
      },
      PAX_MSG_OVERRIDE: {
        animation: true,
        templateUrl: 'pax-message/components/override.tpl.html',
        controller: 'OverrideCtrl',
        controllerAs: 'override',
        windowClass: 'pax-override-window',
        size: 'sm'
      },
      CREW_BASE_HISTORY: {
        animation: true,
        templateUrl: 'profile/components/crew-base-history.tpl.html',
        controller: 'CrewBaseHistoryController',
        controllerAs: 'crewBaseHistory',
        windowClass: 'crew-base-history-window',
        size: 'lg'
      },
      CREW_PREFERENCE_HISTORY: {
        animation: true,
        templateUrl: 'profile/components/crew-preference-history.tpl.html',
        controller: 'CrewPreferenceHistoryController',
        controllerAs: 'crewPreferenceHistory',
        windowClass: 'crew-preference-history-window',
        size: 'lg'
      },
      CREW_SECONDARY_BASE_HISTORY: {
        animation: true,
        templateUrl: 'profile/components/crew-secondary-base-history.tpl.html',
        controller: 'CrewSecondaryBaseHistoryController',
        controllerAs: 'crewSecondaryBaseHistory',
        windowClass: 'crew-secondary-base-history-window',
        size: 'lg'
      },
      MANAGEMENT_POSITION_HISTORY: {
        animation: true,
        templateUrl: 'profile/components/management-position-history.tpl.html',
        controller: 'ManagementPositionHistoryController',
        controllerAs: 'managementPositionHistory',
        windowClass: 'management-position-history-window',
        size: 'md'
      },
      PAX_MSG_DETAILS:{
        animation: true,
        templateUrl: 'crewing_pax_msg_details.tpl.html',
        controller: 'paxMsgDetailsCtrl',
        controllerAs: 'paxMsgDet',
        windowClass: 'table-modal-window',
        size: 'sm'
      },
      GD_CREW_TYPE_SELECT_POPUP: {
        animation: true,
        templateUrl: 'duty-sheet/views/confirm-gd-print-crew-type-dialog.tpl.html',
        controller: 'ConfirmGDPrintCrewTypeDialogCtrl',
        controllerAs: 'gdPrintCrewTypeCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      } ,

      DO_SIGN_IN: {
        animation: true,
        templateUrl: 'missing-sign-in/components/sign-in-popup.tpl.html',
        controller: 'SignInCtrl',
        controllerAs: 'signIn',
        windowClass: 'do-sign-in-window',
        size: 'sm'
      },
      DO_SIGN_OUT: {
        animation: true,
        templateUrl: 'missing-sign-in/components/sign-out-popup.tpl.html',
        controller: 'SignOutCtrl',
        controllerAs: 'signOut',
        windowClass: 'do-sign-out-window',
        size: 'sm'
      },
      ACTIVATE_FLIGHT_REPORT: {
        animation: true,
        templateUrl: 'missing-sign-in/components/report-activation-popup.tpl.html',
        controller: 'reportActivationCtrl',
        controllerAs: 'reportActivation',
        windowClass: 'activate-flight-report',
        size: 'sm'
      },
      EXTEND_DEADLINE_TIME: {
        animation: true,
        templateUrl: 'missing-sign-in/components/extend-deadline-popup.tpl.html',
        controller: 'deadlineExtendCtrl',
        controllerAs: 'deadlineExtend',
        windowClass: 'extend-deadline-time',
        size: 'sm'
      },
      OTHER_HUB_OVERLAPPING_POPUP: {
        animation: true,
        templateUrl: 'profile/views/confirm-other-hub-overlapping-dialog.tpl.html',
        controller: 'ConfirmOtherHubOverlappingDialogCtrl',
        controllerAs: 'otherHubOverlappingCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm'
      } ,
      OTHER_HUB_EDIT_POPUP: {
        animation: true,
        templateUrl: 'profile/views/edit-other-hub-dialog.tpl.html',
        controller: 'otherHubEditCtrl',
        controllerAs: 'otherHubEditCtrl',
        windowClass: 'other-hub-edit-modal-window',
        size: 'md'
      } ,
      LAYOVER_ACCOMMODATION_PREFERENCE_EDIT_POPUP: {
        animation: true,
        templateUrl: 'profile/views/edit-layover-accommodation-preference-dialog.tpl.html',
        controller: 'layoverAccommodationPreferenceEditCtrl',
        controllerAs: 'layoverAccommodationPreferenceEditCtrl',
        windowClass: 'layover-accommodation-preference-edit-modal-window',
        size: 'md'
      },
      OTHER_HUB_IMPORT_POPUP: {
        animation: true,
        templateUrl: 'profile/views/import-other-hub-dialog.tpl.html',
        controller: 'otherHubImportCtrl',
        controllerAs: 'otherHubImportCtrl',
        windowClass: 'other-hub-edit-modal-window',
        size: 'md'
      } ,
      MAX_BIDDING_SETTINGS : {
        animation: true,
        templateUrl: 'bidding/components/max-bidding-settings-popup.tpl.html',
        controller: 'maxCrewBiddingctrl',
        controllerAs: 'crewMaxBidding',
        windowClass: 'max-crew-bidding-modal-window',
        size: 'md'
      },
      ADD_FLYING_HOURS_RANGE : {
        animation: true,
        templateUrl: 'payment-rates/components/add-flying-hour-range-popup.html',
        controller: 'flyingHoursRangePopupCtrl',
        controllerAs: 'paymentRates',
        windowClass: 'add-flying-hours-modal-window',
        size: 'md'
      },
      ADD_CREW_FLYING_HOURS_RANGE : {
        animation: true,
        templateUrl: 'profile/components/add-crew-flying-hour-range-popup.html',
        controller: 'crewFlyingHoursRangePopupCtrl',
        controllerAs: 'crewFlyingHoursRangePopupCtrl',
        windowClass: 'add-crew-flying-hours-modal-window',
        size: 'md'
      },
      EDIT_VOYAGE_REPORT_DETAILS : {
        animation: true,
        templateUrl: 'voyage-report/components/edit-voyage-report-popup.tpl.html',
        controller: 'editVoyageReportPopupCtrl',
        controllerAs: 'editVoyageReport',
        windowClass: 'voyage-report-modal-window',
        size: 'lg'
      },
      EDIT_CABIN_FLIGHT_DETAILS : {
        animation: true,
        templateUrl: 'cabin-flight-admin/components/edit-cabin-flight-admin-popup.tpl.html',
        controller: 'editCabinFlightPopupCtrl',
        controllerAs: 'editCabinFlight',
        windowClass: 'edit-cabin-flight-modal-window',
        size: 'lg'
      },
      VIEW_CABIN_FLIGHT_DETAILS : {
        animation: true,
        templateUrl: 'cabin-flight-admin/components/view-cabin-flight-admin-popup.tpl.html',
        controller: 'viewCabinFlightPopupCtrl',
        controllerAs: 'viewCabinFlight',
        windowClass: 'view-cabin-flight-modal-window',
        size: 'lg'
      },
      APPROVE_CABIN_FLIGHT_DETAILS : {
        animation: true,
        templateUrl: 'cabin-flight-admin/components/approve-cabin-flight-admin-popup.tpl.html',
        controller: 'approveCabinFlightPopupCtrl',
        controllerAs: 'approveCabinFlightAdminCtrl',
        windowClass: 'approve-cabin-flight-modal-window',
        size: 'md'
      },
      DELAY_CODE: {
        animation: true,
        templateUrl: 'flight-punctuality/views/view-delay-codes-popup.tpl.html',
        controller: 'delayCodesPopupCtrl',
        controllerAs: 'delayCodesCtrl',
        windowClass: 'delay-codes-modal-window',
        size: 'lg'
      },
      EXTERNAL_TRAINEES: {
                animation: true,
                templateUrl: 'training-schedule/views/assign_external_trainees_details.tpl.html',
                controller: 'AssignExternalTraineesDetailsCtrl',
                controllerAs: 'assignExtTrneeCtrl',
                windowClass: 'table-modal-window',
                size: 'sm'
      },
      ROTATION_SUMMARY_POPUP: {
        animation: true,
        templateUrl: 'flight-watch/views/rotation-summary-popup.tpl.html',
        controller: 'RotationSummaryCtrl',
        controllerAs: 'RotationSummaryCtrl',
        windowClass: 'rotation-summary-modal-window',
        size: 'lg'
      },
      CONFIG_ROTATION_POPUP: {
        animation: true,
        templateUrl: 'flight-watch/views/run-new-rotation-popup.tpl.html',
        controller: 'RunNewRotationCtrl',
        controllerAs: 'RunNewRotationCtrl',
        windowClass: 'run-new-rotation-modal-window',
        size: 'md'
      },
      UNASSIGN_ROTATION_CONFIRMATION_POPUP: {
        animation: true,
        templateUrl: 'aircraft-registration/views/confirm-unassign-rotation-dialog.tpl.html',
        controller: 'ConfirmUnassignRotationDialogCtrl',
        controllerAs: 'ConfirmUnassignRotationDialogCtrl',
        windowClass: 'run-unassign-rotation-modal-window',
        size: 'md'
      },
      CREW_DETAILS: {
        animation: true,
        templateUrl: 'flight-punctuality/views/view-crew-details-popup.tpl.html',
        controller: 'crewDetailsPopupCtrl',
        controllerAs: 'crewDetailsCtrl',
        windowClass: 'delay-codes-modal-window',
        size: 'md'
      },
      FLIGHT_LOG: {
        animation: true,
        templateUrl: 'flight-punctuality/views/view-flight-log-details-popup.tpl.html',
        controller: 'flightLogDetailsPopupCtrl',
        controllerAs: 'flightLogDetailsCtrl',
        windowClass: 'delay-codes-modal-window',
        size: 'md'
      },

      SHOW_TRAINING_AUTOMATION_SUMMARY : {
                templateUrl: 'show_training_automation_summary.tpl.html',
                animation: true,
                controller: 'TrainingAutomationSummaryCtrl',
                controllerAs : 'trainingAutomationSummary',
                windowClass: 'table-modal-window',
                size: 'sm'
       },
       ASSIGNED_TRAINEES: {
            animation: true,
            templateUrl: 'training-roster/components/assigned-trainees.tpl.html',
            controller: 'TrainingCrewAssignmentCtrl',
            controllerAs: 'TrainingCrewAssignmentCtrl',
            windowClass: 'alert-small-modal-window',
            size: 'sm'
          },
      SHOW_CREDIT_HOURS:{
          animation: true,
          templateUrl: 'credit-hours-popup.tpl.html',
          controller: 'CreditHoursCtrl',
          controllerAs: 'creditHours',
          windowClass: 'run-unassign-rotation-modal-window',
          size: 'md'
      },
      SHOW_TRAINING_STAGES:{
        animation: true,
        templateUrl: 'training-stages-popup.tpl.html',
        controller: 'TrainingStagesCtrl',
        controllerAs: 'trainingStages',
        windowClass: 'run-unassign-rotation-modal-window',
        size: 'md'
      },
      SHOW_MESSAGE_RECEIVER: {
        animation: false,
        templateUrl: 'message-admin/components/message-admin-receiver-popup.tpl.html',
        controller: 'MessageReceivePopupCtrl',
        controllerAs: 'MessageReceivePopupCtrl',
        size: 'lg',
        keyboard :false
      },
      CONFIRM_ILLEGAL_FLEET_CREW_ASSIGN: {
        animation: true,
        templateUrl: 'flight-watch/views/confirm-illegal-fleet-crew-assign.tpl.html',
        controller: 'ConfirmIllegalFleetCrewAssignCtrl',
        controllerAs: 'illegalFleetCrewAssign',
        windowClass: 'run-unassign-rotation-modal-window',
        size: 'md'
      },
      DEADHEAD_TRAVEL_REQUEST: {
        animation: true,
        templateUrl: 'deadhead_travel_response.tpl.html',
        controller: 'DeadheadTravelCtrl',
        controllerAs: 'deadheadTravel',
        windowClass: 'missing-items-popup-window',
        size: 'lg',
        backdrop: 'static',
        keyboard :false
      },
      ADD_ROSTER_SCORE_VERSION: {
        animation: true,
        templateUrl: 'add_roster_score_version.tpl.html',
        controller: 'RosterScoreVersionCtrl',
        controllerAs: 'scoreVersion',
        windowClass: 'add-memo-modal-window',
        size: ''
      },
      SHOW_ROSTER_SCORING:{
        animation: true,
        templateUrl: 'roster-scoring-popup.tpl.html',
        controller: 'ScoringPopupCtrl',
        controllerAs: 'scoringPopup',
        windowClass: 'run-unassign-rotation-modal-window',
        size: 'lg'
      },
      SHOW_CMND_DESCRETION_SCORING:{
          animation: true,
          templateUrl: 'admin_cmnd_descretion-popup.tpl.html',
          controller: 'CmndDescretionPopupCtrl',
          controllerAs: 'cmndDescretionPopup',
          windowClass: 'run-unassign-rotation-modal-window',
          size: 'lg'
      },
      SHOW_EXCLUSION_VIOLATION:{
        animation: true,
        templateUrl: 'profile/views/exclusion-violation-popup.tpl.html',
        controller: 'ExclusionViolationPopupCtrl',
        controllerAs: 'exclusionViolationPopup',
        windowClass: 'run-unassign-rotation-modal-window',
        size: 'lg'
      },
      VIEW_CONFIRM_PAIRING_MODAL: {
        animation: true,
        templateUrl: 'pairing-assignment-complement-confirmation-modal/views/pairing-assignment-complement-confirmation-modal.tpl.html',
        controller: 'pairingAssignmentComplementConfirmationModalCtrl',
        controllerAs: 'pairingAssignmentComplementConfirmationModal',
        windowClass: 'alert-small-modal-window',
        size: 'sm'
      },
      ADD_CABIN_FLIGHT_FEEDBACK : {
        animation: true,
        templateUrl: 'cabin-flight-admin/components/add-cabin-flight-feedback-popup.tpl.html',
        controller: 'addCabinFlightFeedbackPopupCtrl',
        controllerAs: 'addCabinFlightFeedbackPopup',
        windowClass: 'add-cabin-flight-feedback-modal-window',
        size: 'lg'
      },
      SEND_CHANGE_NOTIFICATION: {
        animation: true,
        templateUrl: 'crew-schedule/views/send-change-notification.tpl.html',
        controller: 'crewScheduleNotificationCtrl',
        controllerAs: 'crewScheduleNotificationCtrl',
        windowClass: 'crew-shedule-change-notification-modal-window',
        backdrop  : 'static',
        size: 'md',
        keyboard :false
      },
      SEND_NOTIFICATION: {
        animation: true,
        templateUrl: 'crew-schedule/views/send-notification.tpl.html',
        controller: 'SendNotificationCtrl',
        controllerAs: 'sendNotif',
        windowClass: 'sms-modal-window',
        size: 'lg'
      },
      CONFIRM_OVERLAP: {
        animation: true,
        templateUrl: 'confirm_overlap.tpl.html',
        controller: 'ConfirmOverlapCtrl',
        controllerAs: 'confirmCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      },
      SWO_CONVERTION_REMARKS: {
        animation: true,
        templateUrl: 'crew-schedule/views/add_operation_remarks.tpl.html',
        controller: 'AddOperationRemarksCtrl',
        controllerAs: 'addOperationRemarksCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      },
      CANCEL_FLIGHT_DIALOG: {
        animation: true,
        templateUrl: 'flight-watch/views/flight-watch-cancel-flight-popup.html',
        controller: 'FlightCancelCtrl',
        controllerAs: 'flightCancelCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      },
      EDIT_ROSTER_CYCLE: {
        animation: true,
        templateUrl: 'cycle/views/edit-roster-cycle.html',
        controller: 'editRosterCycleCtrl',
        controllerAs: 'editRosterCycleCtrl',
        windowClass: 'edit-roster-cycle-modal-window',
        backdrop  : 'static',
        size: 'md',
        keyboard :true
      },SBY_CALL_OUT: {
        animation: true,
        templateUrl: 'sby_call_out.tpl.html',
        controller: 'SBYCallOutCtrl',
        controllerAs: 'sbyCallOutCtrl',
        windowClass: 'alert-small-modal-window',
        size: 'sm',
        backdrop  : 'static',
        keyboard :false
      },
      DELAYED_REPORT_TIMING: {
        animation: true,
        templateUrl: 'delayed_report_timing.tpl.html',
        controller: 'DelayedReportTimingCtrl',
        controllerAs: 'DelayedReportTimingCtrl',
        windowClass: 'delayed-report-timing-window',
        backdrop  : 'static',
        size: 'lg'
      },
      IGNORE_REGULATION_VIOLATION: {
        animation: true,
        templateUrl: 'crew-schedule/views/ignore-regulation-violations.tpl.html',
        controller: 'ignoreRegulationViolationsCtrl',
        controllerAs: 'controller',
        windowClass: 'ignore-and-restore-violations-modal-window',
        size: 'md',
        backdrop  : 'static',
        keyboard :true
      },
      RESTORE_REGULATION_VIOLATION: {
        animation: true,
        templateUrl: 'crew-schedule/views/restore-regulation-violations.tpl.html',
        controller: 'ignoreRegulationViolationsCtrl',
        controllerAs: 'controller',
        windowClass: 'ignore-and-restore-violations-modal-window',
        size: 'md',
        backdrop  : 'static',
        keyboard :true
      },
      CREW_ACMI_OPS_HISTORY: {
        animation: true,
        templateUrl: 'profile/components/crew-acmi-ops-history.tpl.html',
        controller: 'CrewACMIopsHistoryController',
        controllerAs: 'crewACMIHistory',
        windowClass: 'crew-acmi-history-window',
        size: 'lg'
      },
      GD_TEMPLATE_SELECT_POPUP: {
              animation: true,
              templateUrl: 'duty-sheet/views/select-gd-template-popup.tpl.html',
              controller: 'ConfirmGDPrintTemplateCtrl',
              controllerAs: 'gdPrintTemplateCtrl',
              windowClass: 'alert-small-modal-window',
              size: 'sm',
              backdrop  : 'static',
              keyboard :false
            } ,

      WARNING: {
                    animation: true,
                    templateUrl: 'warning.tpl.html',
                    controller: 'ConfirmDialogCtrl',
                    controllerAs: 'confirmCtrl',
                    windowClass: 'alert-small-modal-window',
                    size: 'sm',
                    backdrop  : 'static',
                    keyboard :false
                  },

      OVERRIDE_CONFIRM: {
                    animation: true,
                    templateUrl: 'override_confirm.tpl.html',
                    controller: 'ConfirmDialogCtrl',
                    controllerAs: 'confirmCtrl',
                    windowClass: 'alert-small-modal-window',
                    size: 'sm',
                    backdrop  : 'static',
                    keyboard :false
                  },
    };


    self.openModal = function (type, data, onCloseHandler, options) {
      var config = angular.extend(modalConfig[type] || {},
        {
          resolve: {
            modalParams: function () {
              return data;
            }
          }
        });

      if (angular.isDefined(options)) {
        config = angular.extend(config, options);
      }

            openModals[type] = $uibModal.open(config);
            if (!!onCloseHandler) {
                openModals[type].result.then(
                    onCloseHandler,
                    function(){
                        onCloseHandler.call(this);
                    }
                );
            }
        };



    self.closeModal = function (type) {
      if (!!openModals[type]) {
        openModals[type].close();
      }
    };

    self.closeAllModals = function () {
      angular.forEach(Object.keys(openModals), function (type) {
        openModals[type].close();
      });
    };

    self.openModalInDiv = function (container, type, data, onCloseHandler) {
      var opt = {
        appendTo: $document.find(container),
        backdrop: false
      };
      self.openModal(type, data, onCloseHandler, opt);
    };

    self.openPrintWindow = function () {
      var popupWindow = window.open('popupWindow.html');
      popupWindow.mySharedData = someOtherDataService.importantData;
    };

  }
}());
